import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { ThePractice } from '../components/ThePractice';
import { VeraReserve } from '../components/VeraReserve';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { Questions } from '../components/Questions';
import { SelectedVoices } from '../components/SelectedVoices';
import { Ashley } from '../components/Ashley';
import { Application } from '../components/Application';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full bg-cream min-h-screen selection:bg-brass selection:text-cream" data-id="element-135" data-mp="24j4uuj99s297">
      <TopBar data-id="element-136" data-mp="29i7xjx1s1we0" />
      <Hero data-id="element-137" data-mp="29ihmdhb35xi4" />
      <ThePractice data-id="element-138" data-mp="2dhgsv6cgu2bo" />
      <VeraReserve data-id="element-139" data-mp="2dhyu6hdzj6qg" />
      <WhatsIncluded data-id="element-140" data-mp="2dii69hgyf0wk" />
      <Questions data-id="element-141" data-mp="2dfm41gy2pq2b" />
      <SelectedVoices data-id="element-142" data-mp="3kvafowjiyu0a" />
      <Ashley data-id="element-143" data-mp="3kvtmpi7mzxzj" />
      <Application data-id="element-144" data-mp="3ku8s5slbof1o" />
      <Footer data-id="element-145" data-mp="3kuqth3mudjgg" />
    </main>;
}